import { Box } from "@mui/material";
import { isNil } from "lodash";
import React from "react";

const ImagePreviewBox = ({ imagePreview }) => {
  if (isNil(imagePreview)) {
    return null;
  }
  return (
    <Box
      sx={{
        position: "absolute",
        left: 4,
        top: "50%",
        transform: "translateY(-50%)",
        width: 24,
        height: 24,
        borderRadius: "4px",
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
        background: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={imagePreview}
        alt=""
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "cover",
        }}
      />
    </Box>
  );
};

export default ImagePreviewBox;
